import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Tree } from "@minoru/react-dnd-treeview";
// import { CustomNode } from "./CustomNode";
// import { CustomDragPreview } from "./CustomDragPreview";
import styles from "./FileTree.module.css";
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Dropzone from "react-dropzone";
import { CustomNode } from "./CustomNode";
import { CustomDragPreview } from "./CustomDragPreview";
import { API_URL } from "../../../helpers/api_helper";
import {useSelector} from 'react-redux'

const FileTree = props => {

    const [isVisibleAddFolderModal, setIsVisibleAddFolderModal] = React.useState(false);
    const [folderName, setFolderName] = React.useState("");
    const [treeData, setTreeData] = React.useState(props.defaultValue || []);

    const permissions = useSelector(state => state.User.permissions)

    const handleDrop = (newTree) => setTreeData(newTree);

    const handleValidAddFolderForm = (e, p) => {
      let title = folderName;
      if (!title || title.length === 0) title = "New folder";

      let count = 0;

      let fl = true, tmp = title;
      while (fl) {
        const d = treeData.map(i => i.title.toLowerCase() === tmp.toLowerCase()).filter(i => i);

        if (d.length > 0) {
          count++;
          tmp = title + ` (${count})`;
        } else fl = false;
      }

      if (count > 0) {
        title += ` (${count})`;
      }

      const id = new Date().getTime().toString();
      setTreeData(prev => ([...prev, { id, parent: 0, droppable: true, title }]));
      setFolderName("");
      setIsVisibleAddFolderModal(false);
    };

    const handleAcceptedFiles = files => {
      // console.log(files);
      setTreeData(prev => [...prev, ...files.map((i, index) => ({
        title: i.name,
        id: new Date().getTime().toString() + index + 111,
        parent: 0,
        droppable: false,
        file: i
      }))]);
    };

    React.useEffect(() => {
      if (props.onChange) {

        const dt = [];

        const getPath = item => {
          const f = treeData.find(i => i.id === item.parent);
          let new_path = [];
          if (f) {
            new_path = getPath(f);
          }
          return [...new_path, item.title];
        };

        treeData.forEach(i => {
          if (i.file && !i.droppable) {
            const file = typeof i.file === "string" ? i.file : Object.assign(i.file, {
              preview: URL.createObjectURL(i.file)
            });

            dt.push({
              file,
              path: getPath(i).join("/"),
              id: i.id
            });
          }
        });

        props.onChange(dt);
      }
    }, [treeData]);

    React.useEffect(() => {
      if(props.defaultValue) {
        setTreeData(props.defaultValue)
      }
    }, [props.defaultValue]);

    const onDelete = (node) => {

      const deleteById = (id, data) => {
        let new_data = data;
        if (data.some(i => i.parent === id)) {
          for (const i of data) {
            if (i.parent === id) {
              new_data = deleteById(i.id, new_data);
            } else {

            }
          }
        }
        return new_data.filter(i => i.id !== id);
      };

      setTreeData(prev => deleteById(node.id, prev));
    };

    const onDownload = node => {

      function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        link.target="_blank"
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      const url = typeof node.file === "string"
        ? (process.env.API_URL || API_URL) + node.file
        : URL.createObjectURL(node.file)

      downloadURI(url, node.title)

    };

    return (
      <div className={styles.app}>
        <Modal
          isOpen={isVisibleAddFolderModal}
          toggle={() => setIsVisibleAddFolderModal(prev => !prev)}
          centered
          // className={this.props.className}
        >
          <ModalHeader toggle={() => setIsVisibleAddFolderModal(prev => !prev)} tag="h4">
            Add a folder
          </ModalHeader>
          <ModalBody>
            <div>
              <Row form>
                <Col className="col-12">
                  <div className="mb-3">
                    <AvForm>
                      <AvField
                        name="folder_name"
                        label="Folder name"
                        type="text"
                        errorMessage="Invalid name"
                        onChange={(_, v) => setFolderName(v)}
                        validate={{
                          required: { value: true }
                        }}
                      />
                    </AvForm>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={() => setIsVisibleAddFolderModal(false)}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      onClick={handleValidAddFolderForm}
                      className="btn btn-success save-event"
                    >
                      Save
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
        <Tree
          tree={treeData}
          rootId={0}
          render={(node, { depth, isOpen, onToggle }) => (
            <CustomNode
              node={node}
              depth={depth}
              isOpen={isOpen}
              onToggle={onToggle}
              onDelete={onDelete}
              onDownload={onDownload}
            />
          )}
          dragPreviewRender={(monitorProps) => (
            <CustomDragPreview monitorProps={monitorProps} />
          )}
          onDrop={handleDrop}
          classes={{
            root: styles.treeRoot,
            draggingSource: styles.draggingSource,
            dropTarget: styles.dropTarget
          }}
        />
        {permissions?.["change_clientmodel"] && <React.Fragment>
          <div>
            <Button
              type="button"
              color="success"
              className="mb-2 me-2"
              onClick={() => setIsVisibleAddFolderModal(true)}
            >
              <i className="mdi mdi-plus me-1" />{" "}
              Add folder
            </Button>
          </div>
          <Dropzone onDrop={handleAcceptedFiles}>
            {({ getRootProps, getInputProps }) => (
              <div className="dropzone">
                <div
                  className="dz-message needsclick"
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <div className="mb-3">
                    <i className="display-4 text-muted bx bxs-cloud-upload" />
                  </div>
                  <h4>Drop files here or click to upload.</h4>
                </div>
              </div>
            )}
          </Dropzone>
        </React.Fragment>}
      </div>
    );
  }
;

FileTree.propTypes = {
  onChange: PropTypes.func,
  defaultValue: PropTypes.any,
  permissions: PropTypes.any,
};

const FileTreeStyled = styled.div`

`;

export default (FileTree);
